import React, { useContext, useEffect, useState } from "react";
import { MousePosition } from "ol/control";
import {createStringXY} from "ol/coordinate";
import MapContext from "../Map/MapContext";
import { create } from "ol/transform";

const MousePositionControl = () => {
	const { map } = useContext(MapContext);

	useEffect(() => {
		if (!map) return;

		let MousePositionControl = new MousePosition({
            coordinateFormat: createStringXY(4),
            projection: "EPSG:4326",
        });

		map.addControl(MousePositionControl);

		//return () => map.controls.remove(fullScreenControl);
	}, [map]);

	return null;
};

export default MousePositionControl;